import { EASY_EDU_SERVER_BASE_URL } from "../../../environment";
import { PAYMENT_APIS } from "../api/apis";
import { get, getAxiosHeaders } from "./AxiosAPI";

export const getWebLink = async (poId: string): Promise<string | undefined> => {
  try {
    let headers = getAxiosHeaders();
    const res = await get(PAYMENT_APIS.GET_PAYMENT_WEB_LINK_FOR_PO_ID.replace("poId_value", poId), null);
    return res.data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};
